module.exports = __webpack_public_path__ + "static/media/exmo.d6cb3af6.svg";